import { render, staticRenderFns } from "./plateTables.vue?vue&type=template&id=0147c552&scoped=true&"
import script from "./plateTables.vue?vue&type=script&lang=js&"
export * from "./plateTables.vue?vue&type=script&lang=js&"
import style0 from "./plateTables.vue?vue&type=style&index=0&id=0147c552&lang=scss&scoped=true&"
import style1 from "./plateTables.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0147c552",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCard,VDataTable,VIcon,VTab,VTabs,VTooltip})
